import {
  SlCheckbox
} from "./chunk.2AH6QQO3.js";
import {
  checkbox_card_styles_default
} from "./chunk.QHWCPH4D.js";
import {
  l as l2
} from "./chunk.SQVLNLTX.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  n
} from "./chunk.D5EJUUKV.js";
import {
  $
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/checkbox-card/checkbox-card.ts
var FadvCheckboxCard = class extends SlCheckbox {
  constructor() {
    super(...arguments);
    this.hasSlotController = new HasSlotController(this, "sub-heading", "badge");
  }
  handleCardClick(event) {
    event.preventDefault();
    if (event.button !== 0)
      return;
    if (this.disabled)
      return;
    this.input.focus();
    super.handleClick();
  }
  render() {
    return $`<div class=${o({
      "checkbox-card": true,
      "checkbox-card--checked": this.checked,
      "checkbox-card--indeterminate": this.indeterminate,
      "checkbox-card--has-sub-heading": this.hasSlotController.test("sub-heading"),
      "checkbox-card--has-badge": this.hasSlotController.test("badge"),
      "checkbox-card--disabled": this.disabled,
      "checkbox-card--focused": this["hasFocus"]
    })} @mousedown=${this.handleCardClick} ><div class="checkbox-card__inner"><div class="checkbox-card__checkbox-container"><div class="checkbox-card__checkbox"><fadv-icon class="checkbox-card__checkbox-background" size="medium" outline foreground="primary" background="white"></fadv-icon><fadv-icon class="checkbox-card__checkbox-check" size="medium" foreground="white" background="primary" library="solid" name="fa-check" ></fadv-icon><fadv-icon class="checkbox-card__checkbox-indeterminate" size="medium" foreground="white" background="primary" library="solid" name="fa-minus" ></fadv-icon><input type="checkbox" name=${l(this.name)} value=${l(this.value)} .indeterminate=${l2(this.indeterminate)} .checked=${l2(this.checked)} .disabled=${this.disabled} .required=${this.required} role="checkbox" aria-checked=${this.checked ? "true" : "false"} @click=${this.handleClick} @blur=${this.handleBlur} @focus=${this.handleFocus} /></div></div><div class="checkbox-card__heading-container"><fadv-typography type="paragraph-large" weight="500"><slot></slot></fadv-typography><fadv-typography type="paragraph-small" variant="primary" weight="500"><slot name="sub-heading"></slot></fadv-typography></div></div><div class="checkbox-card__badge-container"><div class="checkbox-card__badge"><slot name="badge"></slot></div></div></div>`;
  }
};
FadvCheckboxCard.styles = checkbox_card_styles_default;
FadvCheckboxCard = __decorateClass([
  n("fadv-checkbox-card")
], FadvCheckboxCard);

export {
  FadvCheckboxCard
};
